export default "__VITE_ASSET__354e5ccf__"